import { render, staticRenderFns } from "./goodsTypeList.vue?vue&type=template&id=5a2143e8&scoped=true"
import script from "./goodsTypeList.vue?vue&type=script&lang=js"
export * from "./goodsTypeList.vue?vue&type=script&lang=js"
import style0 from "./goodsTypeList.vue?vue&type=style&index=0&id=5a2143e8&prod&lang=css"
import style1 from "./goodsTypeList.vue?vue&type=style&index=1&id=5a2143e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2143e8",
  null
  
)

export default component.exports